import { useEffect } from 'react';

/**
 * Appelle `onReturn` quand l'onglet redevient visible.
 *
 * C'est la seule relecture automatique du journal (ADR 0035 §4) : pas de
 * minuterie, parce que chaque lecture s'y inscrit elle-meme. Le retour sur
 * l'onglet est un geste de l'exploitant, pas un battement d'horloge.
 */
export const useReloadOnReturn = (onReturn: () => void): void => {
  useEffect(() => {
    const listener = (): void => {
      if (document.visibilityState === 'visible') {
        onReturn();
      }
    };

    document.addEventListener('visibilitychange', listener);

    return () => {
      document.removeEventListener('visibilitychange', listener);
    };
  }, [onReturn]);
};
